import {
  Empty,
  EmptyDescription,
  EmptyHeader,
} from "@volca/ui/components/ui/empty";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { emptyStateVariants } from "@volca/ui/lib/empty-state";
import { SectionHeading, ZonedDateTime } from "@/accounts-payable/common";
import type { ApPurchaseDocument } from "@/accounts-payable/types";

export const InvoiceActivitySection = ({
  invoice,
}: {
  invoice: Pick<ApPurchaseDocument, "system_messages">;
}) => (
  <Stack className="w-full" align="start" gap={4}>
    <SectionHeading>Activity</SectionHeading>
    {invoice.system_messages.length > 0 ? (
      <Stack className="w-full" align="start" gap={4}>
        {invoice.system_messages.map((m) => (
          <Stack align="start" key={m.id} gap={1}>
            <Text tone="muted">{m.content}</Text>
            <Text variant="caption" tone="muted">
              <ZonedDateTime value={m.created_at} />
            </Text>
          </Stack>
        ))}
      </Stack>
    ) : (
      <Empty className={emptyStateVariants({ layout: "inline" })}>
        <EmptyHeader>
          <EmptyDescription>No activity yet.</EmptyDescription>
        </EmptyHeader>
      </Empty>
    )}
  </Stack>
);
